import * as React from 'react';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

const testId = 'gc-logo-icon';
export function GCLogo({ size = 'small' }: IconProps) {
    return (
        <svg width={IconSizes[size]} height={IconSizes[size]} viewBox="0 0 40 20" fill="none" data-testid={testId}>
            <path
                fill="#00F092"
                fillRule="evenodd"
                d="M28.759 16.18c-.807 0-1.582-.193-2.324-.516a5.235 5.235 0 0 1-1.84-1.42 5.81 5.81 0 0 1-1.097-2.066 5.869 5.869 0 0 1-.162-2.485c.323-2.26 2.034-4.164 4.26-4.712.13-.032.872-.162 1.84-.162h6.133c.032 0 .84 0 1.614-.355 1.226-.677 1.969-2 1.969-3.389V.946H28.759c-4.325 0-8.102 3.002-9.134 7.262v.097h-5.713c-2.066 0-3.744 1.646-3.841 3.744v.13h9.07c0 .064-.033.128-.065.225-.613 1.872-2.227 3.325-4.164 3.809 0 0-.807.194-1.872.161h-2.904c-.969 0-1.711-.129-1.84-.161C5.81 15.6 4.036 13.34 3.97 10.79c0-.29 0-.677.032-1.032.323-2.292 2.033-4.196 4.26-4.745.13-.032.872-.161 1.84-.161h3.131c.032 0 1.097 0 1.904-.517a3.907 3.907 0 0 0 1.679-3.227V.946H9.393C4.326.946.098 5.142.001 10.34a9.43 9.43 0 0 0 2.711 6.778c1.807 1.872 4.325 2.937 6.875 2.937h4.293c2.904 0 5.68-1.388 7.455-3.712 1.84 2.324 4.648 3.712 7.585 3.712h6.423c2.066 0 3.744-1.646 3.841-3.744v-.13H28.759Z"
                clipRule="evenodd"
            />
        </svg>
    );
}
GCLogo.TEST_ID = testId;
